import unitsJson from "./units.json";
import factionsJson from "./factions.json";
import mapDuelJson from "./map_duel.json";
import type { UnitDef, FactionDef, Faction, MapDef } from "./types";

// Typed views over the raw JSON. The `as` casts are the single trust boundary
// between hand-authored data and the strongly-typed sim.
export const UNIT_DEFS: Record<string, UnitDef> = unitsJson as unknown as Record<string, UnitDef>;
export const FACTION_DEFS: Record<Faction, FactionDef> = factionsJson as unknown as Record<Faction, FactionDef>;
export const DUEL_MAP: MapDef = mapDuelJson as unknown as MapDef;

export function getDef(id: string): UnitDef {
  const d = UNIT_DEFS[id];
  if (!d) throw new Error(`Unknown unit def: ${id}`);
  return d;
}

export function getFaction(id: Faction): FactionDef {
  return FACTION_DEFS[id];
}

export * from "./types";
